import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { Context } from '../../App';
import { API } from '../../conf';

const CancelDon = ({ don, setLoad, updateDons, onCancel }) => {
    const { updateConnect } = React.useContext(Context);
    
    const onConfirm = () => {
        setLoad(true);
        const queryParams = new URLSearchParams({_id: don._id}).toString();
        fetch(API.concat(`/dons?${queryParams}`), {
            method:'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.ok) {
                    updateDons()
                    onCancel()
                }
                setLoad(false)
            }
        })
        onCancel();
    };

    return (
        <Box
            sx={{p:3, textAlign: 'center',}}
        >
            <Typography variant="h6" gutterBottom>
                Confirmez-vous l'annulation de ce don ?
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
                <Button variant="contained" color="error" onClick={onConfirm}>
                    Confirmer
                </Button>
                <Button variant="outlined" onClick={onCancel}>
                    Annuler
                </Button>
            </Stack>
        </Box>
    );
}

export default CancelDon;